<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <router-view />
    <!-- <router-link to="/">{{ c.title5 }}</router-link> -->
    <!-- <router-link to="/login">{{ c.title1 }}</router-link> -->
    <!-- <router-link to="/register">{{ c.title2 }}</router-link>
    <router-link to="/forget">{{ c.title3 }}</router-link>
    <router-link to="/change">{{ c.title4 }}</router-link> -->
  </div>
</template>

<script>
import c from "./assets/message/zh-CN";
export default {
  name: "App",
  data() {
    return {
      // isMobile:''
    };
  },
  // created(){
  //   console.log('app.vue')
  //   this.isMobile = window.matchMedia("(max-width: 820px)").matches;
  //   console.log(this.isMobile)
  //   if(this.isMobile == true){
  //     var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
  //     link.type = 'image/x-icon';
  //     link.rel = 'shortcut icon'
  //     link.href = 'static/images/pc_pic25.jpg'
  //     document.getElementsByTagName('head')[0].appendChild(link)
  //   }
  // }
};
</script>

<style lang='scss'>
#app {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  overflow: hidden;
}
@media only screen and (min-width: 280px) and (max-width: 320px) {
  .el-message-box{
    width: 240px !important;
  }
  .el-message {
      min-width: 240px !important;
  }
}
@media only screen and (min-width: 320px) and (max-width: 375px) {
  .el-message-box{
    width: 280px !important;
  }
  .el-message {
      min-width: 280px !important;
  }
}
@media only screen and (min-width: 375px) and (max-width: 413px) {
  .el-message-box{
    width: 335px !important;
  }
  .el-message {
      min-width: 335px !important;
  }
}
@media only screen and (min-width: 413px) and (max-width: 430px) {
  .el-message-box{
    width: 373px !important;
  }
  .el-message {
      min-width: 373px !important;
  }
}
@media only screen and (min-width: 430px) and (max-width: 500px) {
  .el-message-box{
    width: 390px !important;
  }
  .el-message {
      min-width: 390px !important;
  }
}
@media only screen and (min-width: 500px) and (max-width: 820px) {
  .el-message-box{
    width: 460px !important;
  }
  .el-message {
      min-width: 460px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue